<template>
  <!-- 后台模块只负责组织子路由，终端框架由上层 TerminalLayout 常驻。 -->
  <router-view ref="routePage" :key="routeViewKey" />
</template>

<script>
export default {
  name: 'AdminRouterOutlet',
  data () {
    return {
      routePageRefreshKey: 0
    }
  },
  computed: {
    /**
     * 后台页面共用同一个路由出口，页面路径变化时必须创建新的业务页实例。
     * 查询参数不参与 key，避免仅切换飞机等筛选条件时重建整个页面。
     */
    routeViewKey () {
      return `${this.$route.path}:${this.routePageRefreshKey}`
    }
  },
  methods: {
    /** 将终端壳层的刷新请求转发给真正的业务页。 */
    async refreshPage () {
      const page = this.$refs.routePage
      if (page && typeof page.refreshPage === 'function') {
        await page.refreshPage()
        return
      }
      this.routePageRefreshKey += 1
      await this.$nextTick()
    }
  }
}
</script>
